<template>
  <v-flex xs12 text-xs-right>
    <v-tooltip top>
      <template v-slot:activator="{ exitToolTip }">
        <v-btn
          small
          icon
          fab
          color="error"
          dark
          v-on="exitToolTip"
          @click="$router.push({ name: 'home' })"
          class="quitButton"
        >
          <v-icon>highlight_off</v-icon>
        </v-btn>
      </template>
      <span>Kilépés</span>
    </v-tooltip>
    <!--          <v-flex xs3 text-xs-center>
              <v-card flat class="currentResults">
                  <v-layout row wrap text-xs-center>
                      <v-flex xs12class="stat">
                          <img :src="require('@/assets/img/footprint_mod_1.png')" class="statusImages">
                          {{ stepCounter }}
                      </v-flex>
                  </v-layout>
              </v-card>
          </v-flex>
          <v-flex xs3 text-xs-center>
              <v-card flat class="currentResults">
                  <v-layout row wrap text-xs-center>
                      <v-flex xs12 class="stat">
                          <img :src="require('@/assets/img/new_lingron.png')" class="statusImages">
                          {{ lingronCounter }} 
                      </v-flex>
                  </v-layout>
              </v-card>
          </v-flex>
          <v-flex xs3 text-xs-center>
              <v-card flat class="currentResults">
                  <v-layout row wrap text-xs-center>
                      <v-flex xs12 class="stat">
                          &lt;!&ndash; <img :src="require('@/assets/img/footprint_mod_1.png')" class="statusImages">
                          {{ stepCounter }} &ndash;&gt;
                          <v-chip
                            class="pa-2 mt-3 headerPoints margin-y"
                            color="#F9F871"
                          >
                            &lt;!&ndash; +{{ points }} pont &ndash;&gt;
                            +{{ stepCounter + lingronCounter }} pont
                        </v-chip>
                      </v-flex>
                  </v-layout>
              </v-card>
          </v-flex>-->

    <v-dialog v-model="showExitModal" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Biztosan kilépsz?</v-card-title>
        <v-card-text>A jelenlegi állapotot nem mentjük el</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="text-classroom darken-1"
            flat
            @click="showExitModal = false"
            >MÉGSE</v-btn
          >
          <v-btn
            color="text-classroom darken-1"
            flat
            @click="$router.push({ name: 'home' })"
            >KILÉPÉS</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
export default {
  props: ["stepCounter", "lingronCounter", "maxLingron", "fromStepField"],
  methods: {
    redirectSkillersHomePage() {
      window.location.replace("https://skillersnyelviskola.hu");
    },
  },
  data: () => ({
    showExitModal: false,
  }),
  mounted: function() {
    // if back button is pressed
    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {
      let rt = false;
      window.onpopstate = function(event) {
        rt = true;
        return rt;
      };

      let vm = this.$data;
      setTimeout(function() {
        if (rt) {
          vm.showExitModal = true;
          next(false);
        } else {
          next(true);
        }
      }, 500);
    });

    this.$once("hook:destroyed", () => {
      backButtonRouteGuard();
    });
  },
};
</script>

<style lang="scss" scoped></style>
